const initialState = {
    isFetching: false,
    error: {},
    totalScores: {},
    myqolScores: {},
    latestHpi: {},
    activeItems: [],
    isSnapShot: true,
    symptomList: [{
        displayName: 'Belly Pain',
        friendlyUrl: 'belly-pain',
        id: '54f5f63cb840e30277000016'
    }, {
        displayName: 'Bowel Incontinence',
        friendlyUrl: 'bowel-incontinence',
        id: '54f5f63cb840e3027700001d'
    }, {
        displayName: 'Constipation',
        friendlyUrl: 'constipation',
        id: '54f5f63cb840e30277000018'
    }, {
        displayName: 'Diarrhea',
        friendlyUrl: 'diarrhea',
        id: '54f5f63cb840e30277000019'
    }, {
        displayName: 'Difficulty Swallowing',
        friendlyUrl: 'difficulty-swallowing',
        id: '54f5f63cb840e3027700001c'
    }, {
        displayName: 'Gas/Bloating',
        friendlyUrl: 'bloating',
        id: '54f5f63cb840e30277000017'
    }, {
        displayName: 'Heartburn/Reflux',
        friendlyUrl: 'heartburn',
        id: '54f5f63cb840e3027700001a'
    }, {
        displayName: 'Nausea/Vomiting',
        friendlyUrl: 'nausea-vomitin',
        id: '54f5f63cb840e3027700001b'
    }],
    emotionList: [{
        displayName: 'Anticipation',
        friendlyUrl: 'anticipation',
        id: 'Anticipation'
    }, {
        displayName: 'Catastrophizing',
        friendlyUrl: 'catastrophizing',
        id: 'Catastrophe'
    }, {
        displayName: 'Depression',
        friendlyUrl: 'depression',
        id: 'Depression'
    }, {
        displayName: 'Fatigue',
        friendlyUrl: 'fatigue',
        id: 'Fatigue'
    }, {
        displayName: 'Locus of Control',
        friendlyUrl: 'locus-of-control',
        id: 'LOC'
    }, {
        displayName: 'General Anxiety',
        friendlyUrl: 'general-anxiety',
        id: 'General.Anx'
    }, {
        displayName: 'Stigma and Embarrassment',
        friendlyUrl: 'stigma-and-embarrassment',
        id: 'Stigma'
    }, {
        displayName: 'Visceral Anxiety',
        friendlyUrl: 'visceral-anxiety',
        id: 'Visceral.Anx'
    }],
    fakeItemScoresDataListForEmpty: [{
        id: 'fake',
        displayName: 'fake',
        scores: [{
            timestamp: '2017-10-31T06:09:44.746Z',
            percentile: 30
        }, {
            timestamp: '2017-11-03T06:09:44.746Z',
            percentile: 21
        }, {
            timestamp: '2017-11-09T06:09:44.746Z',
            percentile: 36
        }, {
            timestamp: '2017-11-10T06:09:44.746Z',
            percentile: 33
        }, {
            timestamp: '2017-11-18T06:09:44.746Z',
            percentile: 55
        }, {
            timestamp: '2017-11-23T06:09:44.746Z',
            percentile: 58
        }, {
            timestamp: '2017-11-28T06:09:44.746Z',
            percentile: 78
        }],
        timestamp2Score: {
            '2017-10-31T06:09:44.746Z': 30,
            '2017-11-03T06:09:44.746Z': 21,
            '2017-11-09T06:09:44.746Z': 36,
            '2017-11-10T06:09:44.746Z': 33,
            '2017-11-18T06:09:44.746Z': 55,
            '2017-11-23T06:09:44.746Z': 58,
            '2017-11-28T06:09:44.746Z': 78
        }
    }],
    fakeItemScoresDataListForZero: [{
        id: 'fake',
        displayName: 'fake',
        scores: [{
            timestamp: (new Date()).getTime(),
            percentile: NaN
        }],
        timestamp2Score: {
            time: NaN
        }
    }],
    alarmSymptomResponses: []
};

module.exports = initialState;


// WEBPACK FOOTER //
// ./src/common/modules/dashboard/initialState.js